<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Participações' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>
  <ion-grid style="display: inline-block">
    <ion-row *ngIf="(!membro || userProvider.hasConfig(104)) || (!membro || permissaoVisitante)">
      <ion-col size="12" *ngIf="meuCadastro && !userProvider.hasConfig(156)">
        <ion-list lines="full" (click)="anotacoes()">
          <ion-item>
            <i class="fa-solid fa-square-pen icon-list"></i>

            <ion-label>
              <h2 class="item-title">{{'Anotações' | translate}}</h2>
            </ion-label>
            <i class="fa-regular fa-chevron-right icon-list"></i>
          </ion-item>
        </ion-list>
        <div class="linha-horizontal"></div>
      </ion-col>

      <ion-col size="12" *ngIf="!permissaoFamiliares">
        <ion-list lines="full" (click)="familiares(pessoa.id)">
          <ion-item>
            <i class="fa-solid fa-user-group icon-list"></i>

            <ion-label>
              <h2 class="item-title">{{'Familiares' | translate}}</h2>
            </ion-label>

            <i class="fa-regular fa-chevron-right icon-list"></i>
          </ion-item>
        </ion-list>
        <div class="linha-horizontal"></div>
      </ion-col>

      <ion-col size="12">
        <ion-list lines="full" (click)="grupos(pessoa.id)">
          <ion-item>
            <i class="fa fa-users icon-list" aria-hidden="true"></i>

            <ion-label>
              <h2 class="item-title">{{'grupos' | nomenclatura | async}}</h2>
            </ion-label>

            <i class="fa-regular fa-chevron-right icon-list"></i>
          </ion-item>
        </ion-list>
        <div class="linha-horizontal"></div>
      </ion-col>

      <ion-col size="12" *ngIf="userProvider.hasConfig(112)">
        <ion-list lines="full" (click)="ministerios(pessoa.id)">
          <ion-item>
            <i class="fa fa-users icon-list" aria-hidden="true"></i>

            <ion-label>
              <h2 class="item-title">{{'ministerios' | nomenclatura | async}}</h2>
            </ion-label>

            <i class="fa-regular fa-chevron-right icon-list"></i>
          </ion-item>
        </ion-list>
        <div class="linha-horizontal"></div>
      </ion-col>

      <ion-col size="12" *ngIf="pessoa.podeEditar && userProvider.hasConfig(19) && !isConvencao">
        <ion-list lines="full" (click)="mda(pessoa)">
          <ion-item>
            <i class="fa-solid fa-book icon-list"></i>

            <ion-label>
              <h2 class="item-title">{{'mda' | nomenclatura | async}}</h2>
            </ion-label>

            <i class="fa-regular fa-chevron-right icon-list"></i>
          </ion-item>
        </ion-list>
        <div class="linha-horizontal"></div>
      </ion-col>

      <ion-col size="12">
        <ion-list lines="full" (click)="projetos(pessoa.id)">
          <ion-item>
            <i class="fa-solid fa-book-open-reader icon-list" aria-hidden="true"></i>

            <ion-label>
              <h2 class="item-title">
                {{'eventos' | nomenclatura | async}} {{' e ' | translate}} {{'ensinos' | nomenclatura | async}}
              </h2>
            </ion-label>

            <i class="fa-regular fa-chevron-right icon-list"></i>
          </ion-item>
        </ion-list>
        <div class="linha-horizontal"></div>
      </ion-col>

      <ion-col size="12" *ngIf="userProvider.hasConfig(79) && meuCadastro && !isConvencao">
        <ion-list lines="full" (click)="contribuicoes(pessoa.id)">
          <ion-item>
            <i class="fa-solid fa-money-bill-1-wave icon-list"></i>

            <ion-label>
              <h2 class="item-title">{{'Contribuições' | translate}}</h2>
            </ion-label>

            <i class="fa-regular fa-chevron-right icon-list"></i>
          </ion-item>
        </ion-list>
        <div class="linha-horizontal"></div>
      </ion-col>

      <ion-col size="12" *ngIf="!userProvider.hasConfig(127) && !isConvencao">
        <ion-list lines="full" (click)="trilho()">
          <ion-item>
            <i class="fa-solid fa-chart-line-up icon-list"></i>

            <ion-label>
              <h2 class="item-title">{{'Trilho de Crescimento' | translate}}</h2>
            </ion-label>

            <i class="fa-regular fa-chevron-right icon-list"></i>
          </ion-item>
        </ion-list>
        <div class="linha-horizontal"></div>
      </ion-col>

      <ion-col size="12" *ngIf="userProvider.hasPermissao('ACOMPANHAMENTO') && !meuCadastro">
        <ion-list lines="full" (click)="acompanhamentos(pessoa.id)">
          <ion-item>
            <i class="fas fa-user-friends icon-list"></i>

            <ion-label>
              <h2 class="item-title">{{'Acompanhamentos' | translate}}</h2>
            </ion-label>

            <i class="fa-regular fa-chevron-right icon-list"></i>
          </ion-item>
        </ion-list>
        <div class="linha-horizontal"></div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="userProvider.hasPermissao('PESSOA_MIGRAR') && !meuCadastro">
      <ion-col size="12">
        <ion-list lines="full" (click)="migrar(pessoa)">
          <ion-item>
            <i class="fa-solid fa-person icon-list"></i>

            <ion-label>
              <h2 class="item-title">{{'Migrar Cadastro' | translate}}</h2>
            </ion-label>

            <i class="fa-regular fa-chevron-right icon-list"></i>
          </ion-item>
        </ion-list>
        <div class="linha-horizontal"></div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
